import { Button } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import "./Result.css"
const Result = ({name,score}) => {
  const navigate=useNavigate();
  useEffect(() => {
    if(!name)
    {
      navigate("/");
    }
  },[name,navigate]);
  return (
    <div className='result'>
        <span className='title'>
            Final_Score:{score}
        </span>
        <Button variant='contained' size='large' color='secondary' style={{alignSelf:"center",marginTop:20 }} href="/">Go TO Home Page</Button>
    </div>
  )
}

export default Result